var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.magentoBaseUrl && _vm.categories.length)?_c('div',{class:[
    'popular-categories-wrapper',
    'carousel-content' ].concat( _vm.cssClasses
  ),style:(_vm.dynamicStyles)},[_c('div',{staticClass:"items"},[_c('SfCarousel',{staticClass:"carousel",attrs:{"settings":{
        peek: {before: 0,after: 150},
        perView: 8,
        gap: 15,
        breakpoints: {
          1500: { perView: 6 },
          1200: { perView: 4 },
          1023: { perView: 3 },
          768: {
            perView: 2,
            peek: {before: 0,after: 50},
          }
        }
      }}},_vm._l((_vm.categories),function(category,i){return _c('SfCarouselItem',{key:i,staticClass:"carousel__item"},[(category.show_popular_category && category.popular_category_image)?_c('div',{staticClass:"popular-category-item"},[_c('SfButton',{staticClass:"sf-button--pure sf-product-card__link",attrs:{"link":category.url_path + _vm.categoryUrlSuffix}},[_c('SfImage',{staticClass:"sf-product-card__image",attrs:{"src":_vm.magentoBaseUrl + category.popular_category_image,"alt":category.name,"width":200,"height":200}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(category.name))])],1):_vm._e()])}),1)],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }